import React from 'react';
import { Button, ButtonPropsInterface } from '../../app/form/button/button';

interface WebButtonProps extends ButtonPropsInterface {
    tone?: 'brand' | 'neutral';
}

/** Public web CTA with the gradient used by the Investown banner. */
export const WebButton: React.FC<WebButtonProps> = ({ variant, variation = 'filled', tone = 'brand', ...props }) => {
    const isPrimaryAction = variation === 'filled' && (variant === 'primary' || variant === 'secondary');
    let appearance: ButtonPropsInterface['appearance'] = 'classic';
    if (tone === 'neutral' && variation === 'outlined') {
        appearance = 'neutral-outlined';
    } else if (isPrimaryAction) {
        appearance = 'gradient';
    } else if (variant === 'secondary' && variation === 'outlined') {
        appearance = 'secondary-outlined';
    }

    return (
        <Button
            iconGap="xsmall"
            {...props}
            compactIconSpacing
            variant={isPrimaryAction ? 'primary' : variant}
            variation={variation}
            appearance={appearance}
        />
    );
};
